/*!

=========================================================
* Material Kit PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { whiteColor, grayColor } from "assets/jss/material-kit-pro-react.jsx";

const alertTitleBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: "3px 3px 0 0",
  width: "100%",
  height: "4rem",
  color: "#FFFFFF",
  padding: "24px",
  "& h4": {
    fontWeight: 400,
    fontSize: "1.2rem",
  },
};

const alert = {
  // display: "grid",
  // gridTemplateColumns: "100%",
  // gridTemplateRows: "4rem auto",
  minWidth: "45vw",
};

const modalStyle = (theme) => ({
  modalRoot: {
    overflow: "auto",
    display: "block",
  },
  modal: {
    [theme.breakpoints.up("sm")]: {
      maxWidth: "500px",
      margin: "auto",
    },
    borderRadius: "6px",
    overflow: "visible",
    maxHeight: "unset",
    width: "100%",
    marginTop: "130px !important",
  },
  modalHeader: {
    borderBottom: "none",
    paddingTop: "24px",
    paddingRight: "24px",
    paddingBottom: "0",
    paddingLeft: "24px",
    minHeight: "16.43px",
  },
  modalTitle: {
    margin: "0",
    lineHeight: "1.5",
  },
  modalCloseButton: {
    "&, &:hover": {
      color: "#FFFFFF", // Apricot
    },
    "&:hover": {
      opacity: "1",
    },
    cursor: "pointer",
    padding: "1rem",
    margin: "-1rem -1rem -1rem auto",
    backgroundColor: "transparent",
    border: "0",
    WebkitAppearance: "none",
    float: "right",
    fontSize: "1.5rem",
    fontWeight: "700", // Apricot
    lineHeight: "1",
    // textShadow: "0 1px 0 " + whiteColor,
    opacity: ".75",
  },

  modalBody: {
    padding: "24px 24px 16px 24px",
    position: "relative",
    overflow: "visible",
    fontWeight: 400,
    color: "#777",
  },
  modalFooter: {
    padding: "15px",
    textAlign: "right",
    paddingTop: "0",
    margin: "0",
  },
  modalFooterCenter: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  instructionNoticeModal: {
    marginBottom: "25px",
  },
  imageNoticeModal: {
    maxWidth: "150px",
  },
  modalLarge: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "800px",
    },
  },
  modalSmall: {
    [theme.breakpoints.up("sm")]: {
      width: "300px",
      margin: "auto",
    },
    margin: "0 auto",
  },
  modalSmallBody: {
    marginTop: "20px",
  },
  modalSmallFooterFirstButton: {
    margin: "0",
    paddingLeft: "16px",
    paddingRight: "16px",
    width: "auto",
  },
  modalSmallFooterSecondButton: {
    marginBottom: "0",
    marginLeft: "5px",
  },
  modalLogin: {
    // maxWidth: "360px",
    overflowY: "visible",
    width: "100%",
    "& $modalCloseButton": {
      color: whiteColor,
      top: "-10px",
      right: "10px",
      textShadow: "none",
      position: "relative",
    },
    "& $modalHeader": {
      borderBottom: "none",
      paddingTop: "24px",
      paddingRight: "0", // Apricot
      paddingBottom: "0",
      paddingLeft: "0", // Apricot
    },
    "& $modalBody": {
      paddingBottom: "0",
      paddingTop: "0",
    },
    "& $modalFooter": {
      paddingBottom: "0",
      paddingTop: "0",
    },
  },
  modalLoginCard: {
    marginBottom: "0",
    margin: "0",
    "& $modalHeader": {
      paddingTop: "0",
    },
  },
  modalSignup: {
    maxWidth: "900px",
    width: "100%",
    "& $modalHeader": {
      paddingTop: "0",
    },
    "& $modalTitle": {
      textAlign: "center",
      width: "100%",
      marginTop: "0.625rem",
    },
    "& $modalBody": {
      paddingBottom: "0",
      paddingTop: "0",
    },
  },
  modalSignupCard: {
    padding: "40px 0",
    margin: "0",
  },

  // Apricot Alert
  alert,
  alertWide: {
    ...alert,
    minWidth: "75vw",
  },

  alert_secondary: {
    ...alertTitleBase,
    backgroundColor: theme.palette.secondary.dark,
  },

  alert_warning: {
    ...alertTitleBase,
    backgroundColor: theme.palette.warning.main,
  },

  alert_primary: {
    ...alertTitleBase,
    backgroundColor: theme.palette.primary.main,
  },

  alertBody: {
    // gridRow: "2 / 3",
    overflow: "auto",
    "& h2": {
      fontSize: "1.2rem",
    },
  },

  alertText: {
    fontWeight: 400,
    color: "#777",
  },
});

export default modalStyle;
